export const ACCOUNT_LINKED_SUCCESS_MESSAGE =
  'Sync in progress. Sync time may vary.';
